<template>
	<div id="app">
		<el-container class="main-container">
			<el-header>
				<div>
					<span>后台管理系统</span>
				</div>
				<el-button type="danger">退出</el-button>
			</el-header>

			<el-container>
				<el-aside :width="isCollapse ? '64px' : '200px'">
					<div class="toggle-button" @click="toggleCollapse">|||</div>
					<el-menu class="el-menu-vertical-demo" :unique-opened="true" :collapse="isCollapse" :collapse-transition="false" :router="true">
						<el-submenu index="1">
							<template slot="title"><i class="el-icon-platform-eleme"></i><span style="color: #fff;">首页</span></template>
							<el-menu-item-group>
								<el-menu-item index="/welcome"><span>欢迎页</span></el-menu-item>
							</el-menu-item-group>
						</el-submenu>

						<el-submenu index="2">
							<template slot="title"><i class="el-icon-user-solid"></i><span style="color: #fff;">管理员管理</span></template>
							<el-menu-item-group>
								<el-menu-item index="/users"><span>管理员列表</span></el-menu-item>
							</el-menu-item-group>
						</el-submenu>
						
						<el-submenu index="3">
							<template slot="title"><i class="el-icon-user-solid"></i><span style="color: #fff;">分类管理</span></template>
							<el-menu-item-group>
								<el-menu-item index="/cate"><span>分类列表</span></el-menu-item>
							</el-menu-item-group>
						</el-submenu>
						
						<el-submenu index="4">
							<template slot="title"><i class="el-icon-user-solid"></i><span style="color: #fff;">家教管理</span></template>
							<el-menu-item-group>
								<el-menu-item index="/qiche"><span>家教列表</span></el-menu-item>
							</el-menu-item-group>
						</el-submenu>
						
						<el-submenu index="5">
							<template slot="title"><i class="el-icon-user-solid"></i><span style="color: #fff;">请家教管理</span></template>
							<el-menu-item-group>
								<el-menu-item index="/youji"><span>请家教列表</span></el-menu-item>
							</el-menu-item-group>
						</el-submenu>
						
						<el-submenu index="6">
							<template slot="title"><i class="el-icon-user-solid"></i><span style="color: #fff;">做家教管理</span></template>
							<el-menu-item-group>
								<el-menu-item index="/dingdan"><span>做家教列表</span></el-menu-item>
							</el-menu-item-group>
						</el-submenu>
						
						<el-submenu index="7">
							<template slot="title"><i class="el-icon-user-solid"></i><span style="color: #fff;">系统管理</span></template>
							<el-menu-item-group>
								<el-menu-item index="/xitong"><span>系统列表</span></el-menu-item>
							</el-menu-item-group>
						</el-submenu>
						<el-submenu index="8">
							<template slot="title"><i class="el-icon-user-solid"></i><span style="color: #fff;">用户管理</span></template>
							<el-menu-item-group>
								<el-menu-item index="/user"><span>用户列表</span></el-menu-item>
							</el-menu-item-group>
						</el-submenu>
					</el-menu>
					
				</el-aside>
				<el-main>
					<router-view></router-view>
				</el-main>
			</el-container>

		</el-container>
	</div>
</template>

<script>
export default {
	data() {
		return {
			isCollapse: false,
			activePath: ''
		}
	},
	methods: {
		toggleCollapse() {
			this.isCollapse = !this.isCollapse;
		},
	}
}
</script>

<style scoped>
.el-header {
	display: flex;
	justify-content: space-between;
	padding-left: 0;
	align-items: center;
	color: #fff;
	font-size: 20px;
	background: #393B46;
}

.main-container {
	height: 100%;
	width: 100%;
}

.el-aside {
	background-color: #393B46;
}

.el-header img {
	width: 7%;
	margin-left: 10px;
}

.el-header div {
	display: flex;
	align-items: center;
}

.el-header div span {
	margin-left: 15px;
}

.toggle-button {
	background-color: #393B46;
	font-size: 10px;
	color: #fff;
	line-height: 24px;
	text-align: center;
	letter-spacing: 0.2em;
	cursor: pointer;
}

.el-menu {
	height: 90%;
}
.el-menu-vertical-demo{
	background-color: #393B46;
}
/deep/.el-menu-item-group__title{
	padding: 0 !important;
	
}
/deep/.el-submenu__title:hover{
	background: #181B20;
}
/deep/.el-menu-item-group{
	background: #181B20;
}
/deep/.el-menu-item{
	color: #BFBBBB;
}
/deep/.el-menu-item:hover{
	background: #181B20;
}
</style>